import * as React from "react";

const SvgTreeIcon = props => <svg width={17} height={14} viewBox="0 0 17 14" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><g clipPath="url(#clip0_1_2)"><path d="M17 0H0V2H17V0Z" fill="currentColor" /><path d="M17 6H4V8H17V6Z" fill="currentColor" /><path d="M17 12H4V14H17V12Z" fill="currentColor" /></g><defs><clipPath id="clip0_1_2"><rect width={17} height={14} fill="white" /></clipPath></defs></svg>;

export default SvgTreeIcon;